import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { ILearningData } from '../../interface/participant'
import { CLearningData } from '../../constants/participantLearningData'

export interface participant {
    token: string;
    firstName: string;
    lastName: string;
    startDate: string;
    endDate: string;
    uuidOffer: string;
    loading: boolean;
    learningData: ILearningData;
    loadLearningData: boolean;
}

const initialState: participant = {
    token: "",
    firstName: "",
    lastName: "",
    startDate: "",
    endDate: "",
    uuidOffer: "",
    loading: true,
    learningData: CLearningData,
    loadLearningData: true
}

export const participantSlice = createSlice({
    name: 'participant',
    initialState,
    reducers: {
        setToken: (state, action: PayloadAction<string>) => {
            state.token = action.payload
        },

        setFirstName: (state, action: PayloadAction<string>) => {
            state.firstName = action.payload
        },

        setLastName: (state, action: PayloadAction<string>) => {
            state.lastName = action.payload
        },

        setStartDate: (state, action: PayloadAction<string>) => {
            state.startDate = action.payload
        },

        setEndDate: (state, action: PayloadAction<string>) => {
            state.endDate = action.payload
        },

        setUuidOffer: (state, action: PayloadAction<string>) => {
            state.uuidOffer = action.payload
        },

        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload
        },

        setLearningData: (state, action: PayloadAction<ILearningData>) => {
            state.learningData = action.payload
        },

        setLoadLearningData: (state, action: PayloadAction<boolean>) => {
            state.loadLearningData = action.payload
        },
    },
})

// Action creators are generated for each case reducer function
export const {
    setToken,
    setFirstName,
    setLastName,
    setStartDate,
    setEndDate,
    setUuidOffer,
    setLoading,
    setLearningData,
    setLoadLearningData
} = participantSlice.actions

export default participantSlice.reducer